import { secondsToMilliseconds } from 'date-fns';

import { Role } from '../admin/role';

export * from './call-insight-attribution';
export * from './call-insight-review-status.enum';

export const ROLES_THAT_CAN_CALL_WITH_SIPGATE: string[] = [
  Role.Admin,
  Role.CareerCoach,
  Role.OnboardingCandidates,
  Role.Agc,
  Role.OnlineMatches,
];

export const SIPGATE_VOICEMAIL_THRESHOLD_IN_SECONDS = 30;
export const SIPGATE_VOICEMAIL_THRESHOLD_IN_MILLISECONDS = secondsToMilliseconds(SIPGATE_VOICEMAIL_THRESHOLD_IN_SECONDS);
